export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7779.7f74574f.jpg";